import type { ComponentProps } from "react";
import { Checkbox, useCheckboxContext } from "@ark-ui/react";
import { cva, type VariantProps } from "class-variance-authority";
import { isBrowser } from "@base/lib/utils";

export const labelVariants = cva("text-gray-1000 [&:is([data-disabled])]:text-gray-300", {
  variants: {
    size: {
      sm: "text-label3",
      md: "text-label2",
      lg: "text-label1",
    },
  },
  defaultVariants: {
    size: "md",
  },
});

interface labelVariantProps extends VariantProps<typeof labelVariants> {}
type Props = Omit<ComponentProps<typeof Checkbox.Label>, "className">;

const Label = ({ children, ...rest }: Props) => {
  const { getRootProps } = useCheckboxContext();

  const rootId = getRootProps().id;
  const size = ((isBrowser && rootId && document.getElementById(rootId)?.dataset.size) ||
    "md") as labelVariantProps["size"];

  return (
    <Checkbox.Label
      className={labelVariants({
        size,
      })}
      {...rest}
    >
      {children}
    </Checkbox.Label>
  );
};

export default Label;
